import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {createDsScoutingClient} from "@/api/ds_scouting";
import {getDsContext} from "@/utils/dsContext";
import {playerName} from "@/utils/clubSnapshot";
import {DsEmpty, DsTable, DsLink} from "@/components/DsKit";
export default function DsDevelopmentRoster({id, revision}) {
	const context = useSelector(getDsContext);
	const [data, setData] = useState(null),
		[error, setError] = useState(false),
		[retry, setRetry] = useState(0);
	useEffect(() => {
		let active = true;
		setData(null);
		setError(false);
		createDsScoutingClient()
			.lineup(id)
			.then((value) => {
				if (active && context === getDsContext()) setData({value, id, context});
			})
			.catch(() => {
				if (active && context === getDsContext()) setError(true);
			});
		return () => {
			active = false;
		};
	}, [id, revision, context, retry]);
	if (error)
		return (
			<DsEmpty>
				Schieramento non disponibile o accesso non consentito.{" "}
				<button onClick={() => setRetry((n) => n + 1)}>
					Riprova schieramento
				</button>
			</DsEmpty>
		);
	const visible =
		data?.id === id && data.context === context ? data.value : null;
	if (!visible) return <p>Caricamento schieramento condiviso…</p>;
	const {lineup, members} = visible;
	if (!lineup.exists)
		return (
			<DsEmpty>
				Nessuno schieramento confermato per questa rosa.{" "}
				<DsLink to={"/development/rosters/" + id}>Apri rosa completa</DsLink>
			</DsEmpty>
		);
	if (!lineup.moduleAvailable)
		return (
			<DsEmpty>
				Il modulo salvato non è più disponibile: verifica la rosa completa.
			</DsEmpty>
		);
	const people = new Map(
		members.map((row) => {
			const p = row.player || row;
			return [p.id, p];
		}),
	);
	const used = new Set(lineup.slots.flatMap((s) => s.playerIds));
	const label = (id) =>
		people.has(id) ? playerName(people.get(id)) : "Giocatore non disponibile";
	const module = lineup.modules.find((m) => m.id === lineup.moduleId);
	return (
		<>
			<p>
				Modulo confermato: <b>{module?.name || "—"}</b> · {used.size} giocatori
				schierati{" "}
				<DsLink to={"/development/rosters/" + id}>Rosa completa</DsLink>
			</p>
			<DsTable
				columns={[
					{key: "code", label: "Ruolo"},
					{
						key: "starter",
						label: "Titolare",
						render: (s) =>
							s.playerIds[0] ? label(s.playerIds[0]) : "Posto libero",
					},
					{
						key: "alternatives",
						label: "Alternative",
						render: (s) => s.playerIds.slice(1).map(label).join(", ") || "—",
					},
				]}
				rows={lineup.slots}
				rowKey={(s) => s.slotId}
			/>
			<p>
				Panchina:{" "}
				{[...people.values()]
					.filter((p) => !used.has(p.id))
					.map(playerName)
					.join(", ") || "Nessuna"}
			</p>
		</>
	);
}
